import React, { memo } from 'react';

function RenderFieldCheckboxFilter({
  input,
  checked,
  disabled,
  labelName,
  onChange,
  name,
  itemID,
  className
}) {
  
  return (
    <label className={"container-checkbox-filter " + className}>
      {labelName}
      <input
        {...input}
        type="checkbox"
        name={name || input?.name}
        id={name || input?.name}
        disabled={disabled}
        checked={checked || input?.value}
        onChange={onChange || input?.onChange}
        itemID={itemID}
      />
      <span className="check_mark" />
    </label>
  );
}

export default memo(RenderFieldCheckboxFilter);
